/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summarysharevisits2Inputs */

const en_summarysharevisits2 = /** @type {(inputs: Summarysharevisits2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visits through your share links`)
};

const de_summarysharevisits2 = /** @type {(inputs: Summarysharevisits2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besuche über deine Teilen-Links`)
};

/**
* | output |
* | --- |
* | "Visits through your share links" |
*
* @param {Summarysharevisits2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summarysharevisits2 = /** @type {((inputs?: Summarysharevisits2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summarysharevisits2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summarysharevisits2(inputs)
	return de_summarysharevisits2(inputs)
});
export { summarysharevisits2 as "summaryShareVisits" }